import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const Check = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 24 24">
        <path fill={fill} d="M4,12.8l4.8,4.7L20,6.5" />
    </svg>
);

export default Check;
